export const formatNumber = (num) => {
  if (num !== undefined && num !== null) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
};
